import { CellData } from '../../../../../../common/table/TableTypes';
import { getRawTextFromCellContentString } from '../../../../../../common/table/utils/tableCellContentStringUtils';

/**
 * Returns the visible cell value, preferring a persisted formula result when present.
 */
export const getTableCellCalculatedValue = (cellData: CellData | undefined): string | number => {
    if (!cellData) return '';
    if (cellData.resultValue) return cellData.resultValue;
    if (!cellData.value) return '';

    return getRawTextFromCellContentString(cellData.value);
};
